import {gql} from 'apollo-angular';

import { teamFragment } from '../fragments/team.gql';

export const reloadTeamsGql = gql`
    query ReloadTeamsGql($participantId: [Int!]){
        Participant(participantId: $participantId) {
            ${teamFragment}
        }
    }
`;
